// # Utility functions for generating descriptive IDs

// # Generate a timestamp string (YYYYMMDDHHMMSS)
const getTimestampString = () => {
  const now = new Date();
  return now.getFullYear() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0') +
    String(now.getHours()).padStart(2, '0') +
    String(now.getMinutes()).padStart(2, '0') +
    String(now.getSeconds()).padStart(2, '0');
};

// # Generate random string of specified length
const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

// # Generate descriptive ID with prefix
export const generateDescriptiveId = (prefix) => {
  // # Format: prefix_timestamp_randomstring
  const timestamp = getTimestampString();
  const randomStr = generateRandomString(6);
  return `${prefix}_${timestamp}_${randomStr}`;
};

// # Predefined ID generators for different document types
export const generateFeedbackId = () => generateDescriptiveId('FEEDBACK');
export const generateReviewId = () => generateDescriptiveId('REVIEW');
export const generatePageId = () => generateDescriptiveId('PAGE');
export const generateLogId = () => generateDescriptiveId('LOG'); 